module.exports = __webpack_public_path__ + "static/img/trpohy.dc7e1a23.png";